import TableList from "@components/templates/tablelist";
import outboundQuery from './update';
import compUpload from "@components/templates/selectupload";
import { mapState, mapGetters } from "vuex";
import {
    HttpGetOutboundCalculateList,
    HttpOutboundCalculateDelete,
    HttpGetWarehouseNameList
} from '@/service/storageallocation';
export default {
    mixins: [TableList],
    components: {
        outboundQuery,
        compUpload
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // 'quanbu': 0,
                    // 'IN_orderStatus':null,
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            warehouseNameList: []
        }
    },
    created () {
        HttpGetWarehouseNameList().then(res => {
            this.warehouseNameList = res.data.map(item => {
                return {
                    value: item.code, label: `${item.code}(${item.title})`, 
                    attach: {
                        title: item.title,
                        code: item.code,
                        warehouseType: item.warehouseType,
                        active: item.active
                    }
                }
            });
        }, err => {
            // this.$VMessage.error(err.message);
        });
    },
    computed: {
        ...mapGetters("dictionary", [
            "getBillcusorgList",
            "getOrgList",
            "getBillcusAndFbaWareList",
            "getUserManageWarehouseList",
            "getAdminTransferWarehouse"
        ]),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "失效",
                    operate: "delete",
                    theme: "error",
                    batch:true
                },{
                    name: "批量导出",
                    operate: "export",
                    more:true,
                    // batch: true,
                }, {
                    name: "批量导入",
                    operate: "upload",
                    more:true,
                }
            ]
        },
        SearchsData() {
            let style = 'width: 130px;';
            return [
                {
                    label: "客户",
                    tag: 'Select',
                    key: 'EQ_organizationId',
                    options: this.getBillcusorgList,
                    show: true,
                    style: style,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '仓库',
                    tag: 'Select',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getAdminTransferWarehouse,
                    show: true,
                    style: style,
                    props: {
                        filterable: true,
                    }
                }, {
                    label: '日期',
                    tag: 'vDatepicker',
                    key: 'BT_calculateOutboundAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    show: true,
                    style: style
                }
            ]
        },
        columns() {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: '操作',
                width: 70,
                render: this.getOperateNodes,
                // fixed: 'left'
            }, {
                title: '客户',
                render: (h, { row }) => {
                    let orgName = this.getBillcusorgList.filter(item => {
                        return item.value === row.organizationId
                    })[0] || '--';
                    if (orgName !== '--') {
                        orgName = orgName.label;
                    }
                    return <div>{orgName}</div>
                }
            }, {
                title: '仓库',
                key: 'orgWarehouseCode'
            }, {
                title: '仓库名称',
                render: (h, { row }) => {
                    let warehouseName = this.warehouseNameList.filter(item => {
                        return item.value === row.orgWarehouseCode
                    })[0] || '--';
                    if (warehouseName !== '--') {
                        warehouseName = warehouseName.attach.title;
                    }
                    return <div>{warehouseName}</div>
                }
            }, {
                title: '日期',
                key: 'calculateOutboundAt'
            }, {
                title: '出库预测(CBM)',
                key: 'calculateQty'
            }]
        }
    },
    methods: {
        ajaxRequest: HttpGetOutboundCalculateList,
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: '查看',
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: '编辑',
                    show: true,
                    params: id,
                    operate: 'edit'
                }]
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'add': {
                    let url = this.$router.resolve({
                        name: "outboundCalculateUpdate",
                        params: { type: "add" },
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'query': {
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "outboundQuery",
                        activeid: params,
                        type: 'query',
                        showFooter: false
                    }
                    break;
                }
                case 'edit': {
                    let url = this.$router.resolve({
                        name: "outboundCalculateUpdate",
                        params: { type: "edit" },
                        query: {
                            id: params
                        }
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case "delete":
                this.operate = {
                    show: true,
                    alert: "error",
                    title: "失效删除",
                    width: 400,
                    showDesc: true,
                    params: {
                        ids: params
                    },
                    ajaxRequest: HttpOutboundCalculateDelete,
                
                };
                break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/outboundCalculate/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'get',
                    })
                    break;
                case "upload":
                this.operate = {
                    show: true,
                    title: '导入数据',
                    width: 460,
                    showFooter: false,
                    component: "compUpload",
                    localurl:true,
                    actionurl: process.env.VUE_APP_APIURL_FBB + "/api/v2/outboundCalculate/importCalculate",
                    name: "multipartFile",
                    downrul:'/static/template/warehouseOutboundCalculate.xlsx',
                    formdata: [
                        {
                            label: "月份",
                            key: "billMonth",
                            tag: 'vDatepicker',
                            props: {
                                format: 'yyyy-mm',
                                confirm: false,
                            },
                            labelWidth: 50,
                            span:24,
                        },
                    ],
                    
                    // download: () => {
                    //     this.handleWebfs("/static/template/warehouseOutboundCalculate.xlsx", {}, {
                    //         executor: 'download',
                    //         type: 'url'
                    //     });
                    //     // this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlan/transferOutboundPlanTemplate", {}, 'download');
                    // },
                   
                };
                break;
            }
        }
    }
}